import { ContextLoaderProvider } from "@/app/module/loader/index";
import { Loader } from "@/components/loader/index";
import { ThemeCSOProvider } from "@/base/context/index";
import { ServicesProvider } from "@/services";
import { lazy, Suspense } from "react";
import {
  ContextLicenseAgreementProvider,
  ContextLocalizationProvider,
  ContextMenuProvider,
  ContextProfileProvider,
  ContextQueueMessagesProvider,
  ContextQueueProcessProvider,
  ContextRouterProvider,
  ContextShoppingCartProvider,
  ContextSystemViewProvider,
} from "../module/index";

const LayoutApp = lazy(() => import("./layout"));

const LoaderFallback = () => (
  <ThemeCSOProvider>
    <ContextLoaderProvider>
      <Loader />
    </ContextLoaderProvider>
  </ThemeCSOProvider>
);

export const App = () => (
  <Suspense fallback={<LoaderFallback />}>
    <LayoutApp>
      <ServicesProvider>
        <ContextLocalizationProvider>
          <ContextQueueProcessProvider>
            <ContextQueueMessagesProvider>
              <ContextSystemViewProvider>
                <ContextProfileProvider>
                  <ContextMenuProvider>
                    <ContextShoppingCartProvider>
                      <ContextLicenseAgreementProvider>
                        <ContextRouterProvider />
                      </ContextLicenseAgreementProvider>
                    </ContextShoppingCartProvider>
                  </ContextMenuProvider>
                </ContextProfileProvider>
              </ContextSystemViewProvider>
            </ContextQueueMessagesProvider>
          </ContextQueueProcessProvider>
        </ContextLocalizationProvider>
      </ServicesProvider>
    </LayoutApp>
  </Suspense>
);
